import { render, staticRenderFns } from "./Username.vue?vue&type=template&id=22345f72&"
import script from "./Username.vue?vue&type=script&lang=js&"
export * from "./Username.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports